import React, { useEffect } from 'react';
import { getHeight, getWidth } from '../../../../../utils/relativeSizes';
import { GAMEPLAY_ANIMATION_IMAGES } from '../../../../../assets/images';
import { SOUND_KEYS } from '../../../constant';
// import { playSound } from '../../../../classes/sound';
import clsx from 'clsx';
import styles from './styles.module.css'
import { playSound } from '../../../../../classes/sound';

function DiceAnimation({ shouldShowVip = false, diceStyles = {}, source = "" }) {
  useEffect(() => {
    playSound(SOUND_KEYS.ROLL_DICE);
  }, []);

  return (
    <img
      src={(shouldShowVip && source) ? source : GAMEPLAY_ANIMATION_IMAGES.diceLoader}
      alt="Dice Animation"
      className={!shouldShowVip && !source ? clsx(styles.diceAnimation) : ''}
      style={{
        height: getWidth(50),
        width: getWidth(50),
        ...diceStyles,
      }}
    />
  );
}

export default DiceAnimation;
